log = require 'loglevel'
eventManager = require 'eventManager'
deviceManager = require 'deviceManager'
gameModel = require 'gameModel'


class HelpView extends PIXI.Container

  name: 'HelpView'
  cornerRadius: 5
  visible: false
  isHTML: true
  balanceBarHeight: 45
  canClick: false
  isShowing: false

  #----------------------------------------------

  constructor: ->
    super()

    @style =
      fontFamily: gameModel.getFont()
      fontSize: 22
      fill: "#FFFFFF"
      align: "center"
      lineHeight: 32

    @addIframe()

  #----------------------------------------------

  willShow: ->
    @container.style.display = "block"

  #----------------------------------------------

  didHide: ->
    @container.style.display = "none"

  #----------------------------------------------

  showingProgress: (progress) ->
    progress = Math.round progress
    @container.style.left = "#{progress}px"

  #----------------------------------------------

  addIframe: ->

    vp = deviceManager.getWrapperDimensions()
    w = vp.w

    @iframe = document.createElement('iframe')
    @iframe.src = gameModel.getHelpUrl()
    @iframe.style.width = w + 'px'

    @container = document.getElementById 'help-container'
    @container.style["left"] = "#{vp.w}px"
    @container.style["bottom"] = Math.floor(@balanceBarHeight * gameModel.scaledRatio) + 'px'
    @container.style.display = "none"
    @container.style.width = w + 'px'
    @container.appendChild(@iframe)

    @resize()

    # listen for the iframes button click
    receiveMessage = (event) =>
      @buttonClick() if event.data is 'close-help'

    window.addEventListener("message", receiveMessage, false)

  #----------------------------------------------

  addTitle: ->
    txt = __t.str('PAYTABLE').replace(/(.)(?=.)/g, "$1 ")
    @title = new PIXI.Text txt, @style
    @title.y = 20
    @addChild @title
    @title.centerX gameModel.gameWidth

  #----------------------------------------------

  buttonClick: (e)->
    log.info @constructor.name, 'buttonClick'

    return unless @canClick

    eventManager.trigger 'back'

    e.stopPropagation() if e?

  # -------------------------------------------

  resize: ->
    return unless @iframe?
    vp = deviceManager.getViewport()

    w = window.innerWidth

    # return if w is @prevWidth

    @prevWidth = w

    # return unless @isShowing


    @iframe.style.width = w + 'px'
    @container.style.width = w + 'px'
    @container.style["bottom"] = Math.floor(@balanceBarHeight * gameModel.scaledRatio) + 'px'

  # -------------------------------------------

  didShow: ->
    @canClick = true
    @isShowing = true

  # -------------------------------------------

  willHide: ->
    @canClick = false
    @isShowing = false

  # -------------------------------------------

  spacebarHit: ->
    # console.log 'space'

module.exports = HelpView


// WEBPACK FOOTER //
// ./coffee/view/help-view.coffee